import Alert from '../components/Alert.vue';
import Vue from 'vue';
const alertHandler = (titulo, mensaje, tipo, callback, details, detailsHtml, withDetailButton) => {
  const vm = new Vue({
    ...Alert,
    propsData: { titulo, mensaje, tipo, callback, details, detailsHtml, withDetailButton },
  });
  vm.$mount();
  vm.$bvModal.show('alert-modal');
};
export default alertHandler;
